import {CounterLabel, UnderlineNav} from '@primer/react'
import {OverviewInfoContent} from './OverviewInfoContent'
import styles from './Sidebar.module.css'
import {ClientOnly} from '../ClientOnly'

export function OverviewPanel() {
  return (
    <ClientOnly>
      <OverviewPanelContent />
    </ClientOnly>
  )
}

/** Full Overview sidebar panel */
function OverviewPanelContent() {
  return (
    <div className={styles.sidebar}>
      <UnderlineNav aria-label="Sidebar tabs">
        <UnderlineNav.Item aria-current="page">Info</UnderlineNav.Item>
        <UnderlineNav.Item>
          Comments <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>
          Findings <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>Agents</UnderlineNav.Item>
      </UnderlineNav>

      <OverviewInfoContent />
    </div>
  )
}
